import { getProps, setProps } from '../props'
import { clearInvoice } from '../State/invoice'
import { setFetching } from '../State/fetching'
import fetch from '../Services/fetch'

export default (props) => (dispatch) => {

  const prevProps = getProps();
  
  setProps(props);

  if (prevProps && prevProps.match && prevProps.match.params && prevProps.match.params.id !== props.match.params.id) {
    // Clear the old invoice data and show loading state
    dispatch(clearInvoice());
    dispatch(setFetching(true));
    
    // Fetch the new invoice
    dispatch(fetch())
  }

}